"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_query_1 = require("react-query");
const storage_1 = require("firebase/storage");
const moment_1 = tslib_1.__importDefault(require("moment"));
const keyFactory_1 = require("../keyFactory");
/**
 * Obtiene la fecha a partir del nombre de un archivo adjunto, ya sea de la forma:
 * 08-07-2022_10:05:57_nombre o 20220708092912_nombre, en caso de no poder validar
 * la fecha retorna la fecha de mi cumpleaños (fede) 02-05-1999, que es una fecha
 * Vieja y por tanto estará vencida.
 * TODO: Normalizar las fechas
 *
 * @param name nombre del archivo adjunto
 */
function getDate(name) {
    const fecha = name.split("_", 1);
    const momentDate_DD_MM_YYYY = (0, moment_1.default)(fecha, "DD-MM-YYYY");
    const momentDate_YYYY_MM_DD = (0, moment_1.default)(fecha, "YYYY-MM-DD");
    if (momentDate_DD_MM_YYYY.isValid()) {
        return momentDate_DD_MM_YYYY;
    }
    if (momentDate_YYYY_MM_DD.isValid()) {
        return momentDate_YYYY_MM_DD;
    }
    /**
       * Si no logre validar ninguna fecha
       */
    return (0, moment_1.default)("02-05-1999", "DD-MM-YYYY");
}
/**
 * Query encargada de obtener si hay archivos attacheados o no, devuelve true o false.
 *
 * @param patientUid uid del paciente, en caso de ser null o undefined no se triggerea la query.
 * @param outdated A partir de cuando el archivo attacheado es actual o no
 * @returns
 */
function useAmmountAttachedFiles(patientUid, outdated = (0, moment_1.default)().subtract(1, "days")) {
    return (0, react_query_1.useQuery)(keyFactory_1.FirestoreKeys.WithoutCategory({
        name: "attachedFiles",
        path: `storage: ${patientUid}/attached`
    }, [patientUid]), async () => {
        const storage = (0, storage_1.getStorage)();
        const storageRef = (0, storage_1.ref)(storage, `${patientUid}/attached`);
        const ListItems = await (0, storage_1.list)(storageRef);
        const items = ListItems.items;
        if (items.length === 0) {
            return 0;
        }
        const names = items.map(element => element.name);
        const filesDates = names.map(name => getDate(name));
        const OutdatedArray = filesDates.map(fileDate => fileDate?.diff(outdated) > 0);
        return OutdatedArray.filter(file => file).length;
    }, {
        enabled: !!patientUid
    });
}
exports.default = useAmmountAttachedFiles;
